
import { InjectionToken } from '@angular/core';
import { LoggerSinks } from '@knorr-bremse-portals/ngx-components';

import { Performance as NodePerformance } from 'perf_hooks';

export const PERFORMANCE = new InjectionToken<Performance | NodePerformance>('api:performance');

export enum Loggers {
  Renderer = 'renderer',
  Cache = 'cache',
  HttpClient = 'httpClient',
  Performance = 'performance',
}

export type RequestContext = {
  loggers: LoggerSinks;
}
